
<form [formGroup]="formGroup" class="grid gr\id-cols-2 gap-4" autocomplete="off">
<!-- Modal header -->
<div class="flex items-center justify-between p-4 border-b rounded-t dark:border-gray-600">
    <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{"link.label.new_category" | translate}}
    </h3>
    <span (click)="closeModal()" mat-dialog-close class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
    </span>
</div>
<!-- Modal body -->
<div class="p-6 pt-2 grid grid-cols-2 gap-4">
        <!-- Category Name -->
        <div [ngClass]="customColors?.length ? 'col-span-2': 'col-span-1'">
            <label for="name" class="block text-base font-medium text-gray-700">{{"label.category_name" | translate}}
                <span class="mandatory-field">*</span>
            </label>
            <input 
            type="text" 
            name="name" 
            formControlName="name"
            maxlength="26"
            id="name" 
            class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base"
            placeholder="{{ 'placeholder.category_name' | translate}}"
            >   
            <p class="text-red-500 text-base mt-2" *ngIf="utilityService.getErrorMessage(formGroup, 'name')">{{utilityService.getErrorMessage(formGroup, 'name') | translate}}</p>     
        </div>

        <!-- Category Color -->
        <div class="col-span-1" *ngIf="!customColors?.length">
            <label for="name" class="block text-base font-medium text-gray-700">{{"label.category_color" | translate}}</label>
            <input 
            type="color" 
            name="color" 
            formControlName="color"
            id="color" 
            style="height: 36px;"
            class="mt-1 block w-full rounded-md border border-gray-300 cursor-pointer focus:border-indigo-500 bg-white px-2 py-2 leading-none text-base"
            >        
        </div>
        <div class="col-span-2">
            <label for="name" class="block text-base font-medium text-gray-700">{{"label.category_color" | translate}}</label>
            <div class="flex items-center space-x-4 pt-2">
                <div class="rounded-full w-8 h-8 cursor-pointer" (click)="selectCustomColor(color);" *ngFor="let color of customColors" [style.background]="color" [ngClass]="{'ring-2 ring-black ring-offset-2': selectedCustomColor === color}"></div>
            </div>
        </div>

        <!-- Estimated Duration -->
        <div class="col-span-2" *ngIf="enableDuration">
            <label for="days" class="block text-base font-medium text-gray-700">{{"label.estimated_duration" | translate}}
                <span class="mandatory-field">*</span>
            </label>
            <div class="flex justify-start space-x-2 w-full">
                <div class="flex">
                    <input 
                        type="number" 
                        name="days" 
                        formControlName="days"
                        id="days" 
                        class="mt-1 w-3/6 block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                        placeholder="{{'placeholder.enter_days' | translate}}"
                    > 
                    <span class="inline-flex items-center mt-1 px-3 text-md text-gray-900 bg-gray-200 border border-l-0 border-gray-300 rounded-r-md">
                        {{"text.days" | translate}}
                    </span>
                </div>
                <div class="flex">
                    <input 
                        type="number" 
                        name="hours" 
                        formControlName="hours"
                        id="hours" 
                        class="mt-1 w-2/6 block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                        placeholder="{{'placeholder.enter_hours' | translate}}"
                    > 
                    <span class="inline-flex items-center mt-1 px-3 text-md text-gray-900 bg-gray-200 border border-l-0 border-gray-300 rounded-r-md capitalize">
                        {{"label.hours" | translate}}
                    </span>
                </div>

                <div class="flex">
                    <input 
                        type="number" 
                        name="minutes" 
                        formControlName="minutes"
                        id="minutes" 
                        class="mt-1 w-2/6 block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                        placeholder="{{'placeholder.enter_minutes' | translate}}"
                    > 
                    <span class="inline-flex items-center mt-1 px-3 text-md text-gray-900 bg-gray-200 border border-l-0 border-gray-300 rounded-r-md capitalize">
                        {{"label.minutes" | translate}}
                    </span> 
                </div>
            </div>
            <p class="text-red-500 text-base mt-2" *ngIf="getDurationRequiredError()">{{getDurationRequiredError() | translate}}</p>
            <p class="text-red-500 text-base mt-2" *ngIf="getDurationError('days')">{{getDurationError('days') | translate}}</p>
            <p class="text-red-500 text-base mt-2" *ngIf="getDurationError('hours')">{{getDurationError('hours') | translate}}</p>
            <p class="text-red-500 text-base mt-2" *ngIf="getDurationError('minutes')">{{getDurationError('minutes') | translate}}</p>
        </div>

        <!-- Category Description -->
        <div class="col-span-2">
            <label for="description" class="block text-base font-medium text-gray-700">{{"label.category_description" | translate}}</label>
            <div class="mt-1 h-60" >
                <text-editor
                    [editorData]="formGroup.controls.description"
                    [options]="textEditorOptions"
                    style="font-size: 14px;"
                    >
                </text-editor>
            </div>
        </div>
</div>
<!-- Modal footer -->
 <div class="flex justify-between items-center p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600">
    <div class="flex items-center space-x-2" *ngIf="moduleName === 'NON_JOB_EVENT'">
        <input type="checkbox" id="mark-as-busy" formControlName="markAsBusy">
        <label for="mark-as-busy" class="cursor-pointer select-none">Mark Attendees as busy</label>
    </div>
     <div class="flex justify-end items-center space-x-2 ml-auto">
         <button (click)="closeModal()" type="button" class="text-gray-500 bg-white hover:bg-gray-100 focus:outline-none rounded-lg border border-gray-200 text-base font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">{{"close.text" | translate}}</button>
         <button (click)="saveCategory()" type="button" class="text-white bg-primary font-medium rounded-lg text-base px-5 py-2.5 text-center">{{"text.save" | translate}}</button>
     </div>
 </div>
</form>
